import { CA_PROVINCES, getENV, US_STATES } from '@libs/common-next';

export const localize = {
    'en-US': {
        stateProvinceSelection: US_STATES,
        stateProvinceLabel: 'State',
        stateProvinceValidation: 'State is required',
        zipPostalCode: 'Zip code',
        zipPostalCodeValidation: 'Zip code is required',
        zipPostalCodeValidationInvalid: 'Zip code is invalid',
        streetAddressValidation: 'Street address is required',
        cityValidation: 'City is required',
    },
    'en-CA': {
        stateProvinceSelection: CA_PROVINCES,
        stateProvinceLabel: 'Province',
        stateProvinceValidation: 'Province is required',
        zipPostalCode: 'Postal code',
        zipPostalCodeValidation: 'Postal code is required',
        zipPostalCodeValidationInvalid: 'Postal code is invalid',
        streetAddressValidation: 'Street address is required',
        cityValidation: 'City is required',
    },
};

const locale = getENV('NEXT_PUBLIC_LOCALE');
export const localized = localize[locale ?? 'en-US'];
